module.exports = __webpack_public_path__ + "img/government_icon.e23de2ce.jpg";